export const iconFontAwesomeMarketingSailboat = (
	<i className="fa-solid fa-sailboat"></i>
);
